import EllipsisIcon from '@clearkit/icons/glyphs/Ellipsis';
import DeleteIcon from '@clearkit/icons/glyphs/Trash';
import { CKActionMenu, CKButton, CKPopover } from '@clearkit/react';

function AllowedSiteMenu({ className, onDelete }) {
  return (
    <CKPopover
      baseId="allowed-site-popover"
      popover={
        <CKActionMenu>
          <CKActionMenu.Item
            icon={<DeleteIcon />}
            onClick={onDelete}
            isDestructive>
            Remove domain
          </CKActionMenu.Item>
        </CKActionMenu>
      }
      options={{ placement: 'bottom-end' }}
      className="z-10"
      aria-label="Popover">
      <CKButton isSmall className={className}>
        <EllipsisIcon />
      </CKButton>
    </CKPopover>
  );
}

export default AllowedSiteMenu;
